// const config = {
//   REACT_APP_API_URL: "http://localhost:5300/dashboard/",
//   REACT_APP_IMAGE_URL: "http://localhost:5300/images",
//   REACT_APP_BASE_URL: "http://localhost:5300/",
// };

const config = {
  REACT_APP_API_URL: "https://backend.thetopplayer.com/dashboard/",
  REACT_APP_IMAGE_URL: "https://backend.thetopplayer.com/images",
  REACT_APP_BASE_URL: "https://backend.thetopplayer.com/",
};

// const config = {
//   REACT_APP_API_URL: "https://crm.intersmarthosting.in/topplayer/dashboard",
//   REACT_APP_IMAGE_URL: "https://crm.intersmarthosting.in/topplayer/images",
//   REACT_APP_BASE_URL: "https://crm.intersmarthosting.in/topplayer/",
// };

// "site":"thetopplayer-staging-990b5",

export default config;
